// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + "main" + "." + "5fd41336c578b149957b" + ".css";
};